import { RootState } from "store";
import { StateCreator } from "zustand";

import { staticInformation } from "common/consts/staticInformation";
import { StaticInformation } from "models/StaticInformation";

export interface GlobalSlice {
  staticInformation: StaticInformation;

  setStaticInformation: () => void;
}

export const createGlobalSlice: StateCreator<
  RootState,
  [["zustand/devtools", never]],
  [],
  GlobalSlice
> = (set, get) => ({
  staticInformation: staticInformation,

  setStaticInformation: () => {
    const supportContact = staticInformation.supportContactInformation;
    const headOffice = staticInformation.headOfficeAddressInformation;

    const enrichedStaticInformation: StaticInformation = {
      ...staticInformation,
      supportContactInformation: {
        ...supportContact,
        hrefPhone: `tel:${supportContact.phone}`,
        hrefEmail: `mailto:${supportContact.email}`
      },
      headOfficeAddressInformation: {
        ...headOffice,
        hrefPhone: `tel:${headOffice.phone}`,
        hrefEmail: `mailto:${headOffice.email}`
      }
    };

    set(
      ({ global }) => ({
        global: {
          ...global,
          staticInformation: enrichedStaticInformation
        }
      }),
      false,
      "global/SET_STATIC_INFORMATION"
    );
  }
});
